import { render, staticRenderFns } from "./protocols.vue?vue&type=template&id=94e29480&scoped=true&"
import script from "./protocols.vue?vue&type=script&lang=js&"
export * from "./protocols.vue?vue&type=script&lang=js&"
import style0 from "./protocols.vue?vue&type=style&index=0&id=94e29480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e29480",
  null
  
)

export default component.exports